// @flow
import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import path from 'ramda/es/path';
import petrovich from 'petrovich';


const empty = {};

export default function useStudentFirstNameGenitive(studentId: string): string {
  const student = useSelector(path(['students', 'data', studentId]), shallowEqual) || empty;

  const res = useMemo(() => {
    const first = path(['name', 'first'], student) || '';
    const gender = path(['gender'], student) || 'androgynous';
    const nameGenitive = petrovich({ first, gender }, 'genitive');

    return nameGenitive.first;
  }, [student]);

  return res;
}
